export default __webpack_public_path__ + "static/media/red_wood.eaa5a85d.jpeg";